import { DateHelper } from "../../../../Common/DateHelper";
import { ODataSelect } from "../../../../Providers.Api/ODataQuery";

export type CostCodeSource = 'Any' | 'SFTP' | 'API' | 'Manual';

export type CostCodeType = 'Any' | 'IBSS Standard Cost Code' | 'Client Code (WBS)' | 'Department Code';
export class CostCode extends ODataSelect
{
    public Cost_Code = "";
    public Cost_Code_Description = ""
    public Cost_Code_Id = "";
    public Cost_Code_Type: CostCodeType = 'Any';
    public EventTime = DateHelper.null();
    public Cost_Code_Source: CostCodeSource = 'Any';

    public init(response: any, nodeId: number): CostCode
    {
        super.init(response, nodeId);
        this.EventTime = DateHelper.fromIsoByNode(response.EventTime, nodeId);
        return this;
    }
}

